module.exports = __webpack_public_path__ + "img/dsci0006.f194e0b3.jpg";